
/**
  * @ngdoc service
  * @name common.service:ShopCartPackagingService
  * 
  * @description
  * A service that manage the shop cart packaging logic.
  *
  * @example
  * <pre>
  * Update box: ShopCartPackagingService.updateBox('standard');
  * </pre>
**/
(function(){
  'use strict';

  angular
      .module('itxApp.common')
      .service('ShopCartPackagingService', ShopCartPackagingService)
  
  ShopCartPackagingService.$inject= [
    '$q',
    'ItxStaticResourceSvc',
    'NavigationService',
    'ngDialog',
    'CmsConfigSvc',
    'logger'
  ]

  function ShopCartPackagingService(
    $q,
    ItxStaticResourceSvc,
    NavigationService,
    ngDialog,
    CmsConfigSvc,
    logger
  ){
      var _this = this;
      
      _this.dialogOpen = false;
      _this.state = {
        model : {
            includeCustomMessage: false,
            customMessage: '',
            includePackaging: false,
            includeGiftTicket: false
        },
        url: {
            help: NavigationService.getHelpURL('giftcard/gift-ticket')
        },
        image : {
            standard: ItxStaticResourceSvc.getImage('giftTicket/standard-box.jpg',true),
            gift: ItxStaticResourceSvc.getImage('giftTicket/gift-box.jpg',true)
        }
      };

      if(window.state){
        window.state.packaging = _this.state;
      } else {
        window.state = {};
        window.state.packaging = _this.state;
      }
      
      
      var service = {
        saveGift:saveGift,
        getInitialState: getInitialState,
        addPackaging: addPackaging,
        deleteGiftPacking: deleteGiftPacking,
        updateBox: updateBox,
        getState: getState,
        openModalGift: openModalGift,
        getStateGift: getStateGift
      };

      return service;
      
      function getStateGift(shopCart) {
        var stateGift = {};
        var deferred = $q.defer();
        
        stateGift.giftPackagingEnabled = false;
        stateGift.giftSelected = shopCart.giftTicket == 1 || shopCart.giftPacking;
        stateGift.showGift = inditex.iStoreJSON.details.showGiftTicket === 1; 

        CmsConfigSvc.getProperty('giftpacking')
          .then(function(res){
            if(res){
              if(shopCart.giftpackingRestriction && shopCart.giftPacking || !shopCart.giftpackingRestriction){
                stateGift.giftPackagingEnabled = true;
              }
            } 
            deferred.resolve(stateGift);
          })
          .catch(function(){
            deferred.resolve(stateGift);
          });

        return deferred.promise;
      }

      function getState(){
        return _this.state;
      }
      
      /**
      * @ngdoc method
      * @name getInitialState
      * @methodOf common.service:ShopCartPackagingService
      * @description
      * Get the initial state of the component with information.
      * If data is undefined it means that we didn't have gift packaging added to the shop cart.
      */
      function getInitialState(data){
          if(data) {
            _this.state.model = {
                includeCustomMessage: !!data.message,
                customMessage: data.message,
                includePackaging: data.giftPacking,
                includeGiftTicket: (data.giftTicket === '1') || !!data.message
            };
          }
          return _this.state;
      }
      /**
      * @ngdoc method
      * @name updateBox
      * @methodOf common.service:ShopCartPackagingService
      * @description
      * Update model when user interacts with the boxes
      * @param {string} type Box type selected by user.
      */
      function updateBox(type){
        _this.state.model.includePackaging=(type==='gift');
      }
      /**
      * @ngdoc method
      * @name savePackaging
      * @methodOf common.service:ShopCartPackagingService
      * @description
      * Add gift packing and/or custom message to an order.
      */
      function saveGift (){
        var promises = [];
        promises.push(addPackaging());
        promises.push(setGiftTicket(_this.state.model.includeGiftTicket));
        return $q.all(promises);
      }
    
      function addPackaging (){
        var deferred = $q.defer();

        var action = {
            action: 'order:addGiftpacking',
            params: {
            storeId: inditex.iStoreId,
              orderId: inditex.iUserJSON.shopCart.id,
              message: (_this.state.model.includeCustomMessage && _this.state.model.customMessage) || '',
              onlyMessage: !_this.state.model.includePackaging,
              languageId: inditex.iLangId
            }
        };
        
        joyr.rest.xRestExecute([action])
        .done(function(){
          deferred.resolve();
        })
        .Catch(function(){
          deferred.reject();
        });

        return deferred.promise;
      }

    /**
     * @ngdoc method
     * @name deleteGiftPacking
     * @methodOf common.service:ShopCartPackagingService
     * Delete the gift packing and/or custom message from an order.
     * @param {bool} deleteAll - If true, deletes the packing and the gift ticket
    */
    function deleteGiftPacking (deleteAll) {
      var deferred = $q.defer();
      
      var action = {
          action: 'order:deleteGiftPacking',
          params: {
              storeId: inditex.iStoreId,
              orderId: inditex.iUserJSON.shopCart.id,
              languageId: inditex.iLangId,
              onlyGiftPacking: (!deleteAll && !_this.state.model.includeCustomMessage )|| undefined,
              onlyMessage: (!deleteAll && _this.state.model.includePackaging ) || undefined
          }
      };
      joyr.rest.xRestExecute([action])
      .done(function(){
        if(deleteAll){
          deferred.resolve(setGiftTicket (false));
        } else {
          deferred.resolve();
        }
        
      })
      .Catch(function(){
        deferred.reject();
      });

      return deferred.promise;
    }

    /**
    * @ngdoc method
    * @name setGiftTicket
    * @methodOf 
    * @description
    * Sets or unsets the gift ticket option for an order.*/
    function setGiftTicket (includeGiftTicket){
        var deferred = $q.defer();

        var action = {
            action: 'order:getGiftTicket',
            params: {
                storeId: inditex.iStoreId,
                orderId: inditex.iUserJSON.shopCart.id,
                gifticket: includeGiftTicket ? 1 : 0,
                languageId: inditex.iLangId
            }
        };
        joyr.rest.xRestExecute([action])
        .done(function(){
            deferred.resolve();
        })
        .Catch(function(){
            deferred.reject();
        });

        return deferred.promise;
    }

    /**
    * @ngdoc method
    * @name openModalGift
    * @methodOf 
    * @description
    * Open Modal gift.*/
    function openModalGift(shopCart){
      if(!_this.dialogOpen){
        _this.dialogOpen = true;
        var dialog = ngDialog.open({ 
            template: '<itx-shop-cart-packaging shop-cart="ngDialogData.shopCart"></itx-shop-cart-packaging>',
            className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ngdialog-gift-ticket',
            plain: true,
            showClose: true,
            data:{
                shopCart: shopCart
            }
        });
        dialog.closePromise.then(function () {
          _this.dialogOpen = false;
        });
      }
    }   

  }

}());